import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage, ValidationMessageType,
} from '@appblocks/codegeneration/types';
import LUISItem from '@appblocks/codegeneration/SettingsConfigurations/LUISItem';

export default class LCDGroup extends BaseFeature {
    constructor() {
        super();
        this.name = 'LCD Setting Folder';
        this.id = 'lcd_group';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'FOLDERID',
                name: 'Folder ID',
                settingType: SettingType.STRING,
                required: true,
                default: 'GEN',
            },
            {
                id: 'NAME',
                name: 'Folder Name',
                settingType: SettingType.STRING,
                required: true,
                default: 'General',
            },
            {
                id: 'SETTINGS',
                name: 'Settings',
                settingType: SettingType.ARRAY,
                refId: 'luis_item',
                required: true,
                showChildren: true,
                default: new Array<BaseFeature>(0),
            },
        ]);
    }

    getDependencies() {
        const dependencies = [
            'luis',
        ];
        return dependencies;
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        const alphanumeric = /^[a-zA-Z0-9]+$/;
        const ID = this.getSettingValue('FOLDERID');
        if (!ID.match(alphanumeric)) {
            errors.push({
                messageType: ValidationMessageType.ERROR,
                message: 'Folder ID must be alphanumeric',
            });
        }

        return errors;
    }

    getCodeBlocks() {
        let blocks: Array<CodeBlock> = [];

        const ID = this.getSettingValue('FOLDERID');
        const NAME = this.getSettingValue('NAME');

        blocks.push({
            location: 'menu.xtxt',
            blockType: BlockType.CODE,
            template: `
>>0\t0\tF\t\t${NAME}...\t^\n`,
        });

        const settings = this.getSettingValue('SETTINGS');
        for (let i = 0; i < settings.length; i += 1) {
            blocks = blocks.concat(settings[i].getCodeBlocks());
        }

        return blocks;
    }
}
